module.exports = __webpack_public_path__ + "static/media/brain-tentacle.cfefca88.svg";